"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loggerConfigurationSchema = void 0;
var _zod = require("zod");
var _LoggerTransportType = require("./types/LoggerTransportType");
var _SeverityLevels = require("./types/SeverityLevels");
var zodRegexOrRegexpLikeString = _zod.z.custom(function(data) {
    if (!(data != null)) {
        return false;
    }
    var hasValidData = data instanceof RegExp || typeof data === 'string';
    return hasValidData ? data : undefined;
}).transform(function(value) {
    return typeof value === 'string' ? new RegExp(value, 'i') : value;
});
var severityLevelKeys = Object.keys(_SeverityLevels.SeverityLevels).filter(function(value) {
    return !/\d+/.test(value);
});
var severityLevelValues = Object.values(_SeverityLevels.SeverityLevels).filter(function(value) {
    return typeof value === 'number';
});
var allowedSeverityOptions = new Set(_to_consumable_array(severityLevelValues).concat(_to_consumable_array(severityLevelKeys), _to_consumable_array(severityLevelKeys.map(function(value) {
    return value.toLowerCase();
}))));
/** This allows severityLevel to be either in number, UPPER_CASE or lowercase */ var zodCoerceSeverityLevel = _zod.z.custom(function(value) {
    if (!(value != null)) {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- type is not important here
    return allowedSeverityOptions.has(value);
}).transform(function(value) {
    return typeof value === 'number' ? value : _SeverityLevels.SeverityLevels[value.toUpperCase()];
});
var loggerConfigurationFilterSchema = _zod.z.object({
    /**
   * Logger name exact match filter
   */ byName: _zod.z.string().optional(),
    /**
   * Logger area name exact match filter
   */ byAreaName: _zod.z.string().optional(),
    /**
   * Logger regexp name filter. It can be RegExp or string that will be converted to RegExp
   */ byNameRegExp: zodRegexOrRegexpLikeString.optional(),
    /**
   * Logger regexp area name filter. It can be RegExp or string that will be converted to RegExp
   */ byAreaNameRegExp: zodRegexOrRegexpLikeString.optional(),
    /**
   * Logger transport type filter
   */ byTransportType: _zod.z.nativeEnum(_LoggerTransportType.LoggerTransportType).optional(),
    /** Minimal severity level type filter */ byMinimalSeverityLevel: zodCoerceSeverityLevel.optional(),
    /** If current group has enabled logging, if false then logging is disabled for matches */ enabled: _zod.z.coerce.boolean()
});
// IMPORTANT: Default values are defined in constants.ts, this schema does not enforce it.
// Enforcing is crutial for merging configurations (Node.js->browser for example)
var loggerConfigurationSchema = exports.loggerConfigurationSchema = _zod.z.object({
    /**
   * Controls if logging is enabled globally. If false then nothing is logged and filters are ignored!
   * @default true
   */ enabled: _zod.z.coerce.boolean().optional(),
    /**
   * Controls default minimal severity levels for logging. Can be overriden with filters array
   * @default process.env.NODE_ENV === 'production' ? SeverityLevels.METRIC : SeverityLevels.DEBUG
   */ minimalSeverityLevel: zodCoerceSeverityLevel.optional(),
    /** Rule groups. These groups have their own filters and if they match then specific configurations are applied. Last to match is applied */ filters: _zod.z.array(loggerConfigurationFilterSchema).optional().default([])
}); /** Input type for the {@link LoggerConfiguration} type  */  //# sourceMappingURL=loggerConfigurationSchema.js.map
